<template>
    <div id="contenedor-eliminar-proyecto-documento-tipo">
      <v-card>
        <v-card-title class="secondary--text"> Eliminar responsable </v-card-title>
        <v-card-text>
          <span class="secondary--text">
            ¿Desea eliminar al responsable {{ proyectoResponsableEliminar.funcionario.nombre }}?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixEliminarProyectoResponsable"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </div>
  </template>

<script>
import mixProyectosResponsables from './mixProyectosResponsables';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarProyectoResponsable',
  mixins: [mixProyectosResponsables],
  props: {
    proyectoResponsableEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

  <style lang="scss" scoped></style>
